module.exports = __webpack_public_path__ + "static/8-6bdfdeab85bc47b0039db4370494d78a.jpg";